import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class BusinessCategoriesAPI {
  static async index(businessTypeIds?: any): Promise<any> {
    const types = Array.isArray(businessTypeIds) ? businessTypeIds.join(',') : businessTypeIds
    const queryString = FormsService.prepareQueryString({ types }, true)
    return (await $http.get(`/business-categories?${queryString}`)).data
  }

  static async getUserBusinessCategories(businessTypeId: number) {
    return (await $http.get(`/users/user-business-categories${businessTypeId ? `/${businessTypeId}` : ''}`)).data
  }

  static async create(body: any) {
    return (await $http.post('/business-categories/add', body)).data
  }

  static async update(body: any) {
    return (await $http.post('/business-categories/update', body)).data
  }

  static async delete(id: number) {
    return (await $http.delete(`/business-categories/delete/${id}`)).data
  }
}

export default BusinessCategoriesAPI
